import angular from 'angular';

(function() {
  'use strict';

  angular.module('app.core').component('idDoAutocompleteFilter', {
    bindings: {
      principalEid: '=?', // Identifiant du DO sélectionné
      disable: '<',
      principalId: '=?'
    },
    controller: DOAutocompleteFilterController,
    templateUrl: require('./id-do-autocomplete-filter.html')
  });

  DOAutocompleteFilterController.$inject = ['PrincipalService'];

  function DOAutocompleteFilterController(PrincipalService) {
    var ctrl = this;
    ctrl.criteriaP = {
      profilBuyerOrSeller: true
    };

    ctrl.searchPrincipals = searchPrincipals;
    ctrl.principals = PrincipalService.getPrincipals(ctrl.criteriaP);
    ctrl.filtredPrincilpals = [];
    ctrl.$onInit = function() {
      if (!ctrl.disable) {
        ctrl.disable = false;
      }
    };

    Object.defineProperty(ctrl, 'principal', {
      get: function() {
        return ctrl.principalEid ? ctrl.principalEid : undefined;
      },
      set: function(value) {
        ctrl.principalEid = value ? value.principalEid : null;
        ctrl.principalId = value ? value.principalId : null;
      }
    });

    function searchPrincipals(value) {
      if (value && value.length >= 2) {
        ctrl.filtredPrincilpals = [];
        angular.forEach(ctrl.principals, function(principal) {
          if (principal.eidWithId.toLowerCase().match(value.toLowerCase())) {
            ctrl.filtredPrincilpals.push(principal);
          }
        });
        return ctrl.filtredPrincilpals;
      }
    }
  }
})();
